import { render, staticRenderFns } from "./TaskV.vue?vue&type=template&id=6574c9d2&scoped=true"
import script from "./TaskV.vue?vue&type=script&lang=ts"
export * from "./TaskV.vue?vue&type=script&lang=ts"
import style0 from "./TaskV.vue?vue&type=style&index=0&id=6574c9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6574c9d2",
  null
  
)

export default component.exports